<template>
    <button @click="toggleMode" class="tailx-btn-simple btn-simple-stone">
        <font-awesome-icon :icon="icon" />
    </button>
</template>

<script setup>
import { useStore } from "vuex";
import { onBeforeMount, reactive, computed, ref } from "vue";

const mode = reactive({ theme: localStorage.getItem("theme") });
const store = useStore();
const isDark = computed(() => store.state.darkMode);

const icon = ref();

onBeforeMount(() => {
    if (mode.theme == "dark") {
        icon.value = "moon";
        if (!isDark) {
            store.dispatch("toggleDarkMode");
        }
    } else if (mode.theme == "light") {
        icon.value = "sun";
    }
});

function toggleMode() {
    if (mode.theme == "light") {
        localStorage.setItem("theme", "dark");
        icon.value = "moon";
        mode.theme = "dark";
        document.documentElement.classList.add("dark");
    } else if (mode.theme == "dark") {
        localStorage.setItem("theme", "light");
        icon.value = "sun";
        mode.theme = "light";
        document.documentElement.classList.remove("dark");
    }

    store.dispatch("toggleDarkMode");
}
</script>

<style></style>
